import logo from "Assets/logo.png";

const SimpleNavbar = () => {
  return (
    <div className="bg-brand-charcoal px-2 lg:px-5 w-full h-auto py-10 text-white text-center flex flex-col gap-10 items-center justify-center">
      <div className="flex flex-col md:flex-row gap-3 text-center items-center justify-center ">
        <img src={logo} alt="Salesmrkt Logo" />
        <p>© {new Date().getFullYear()}, Salesmrkt. All Rights Reserved.</p>
      </div>
    </div>
  );
};

export default SimpleNavbar;
